import axios from 'axios';

type Props = {
    eventUrl: string;
    rotaryCd: string;
}

/**
 * イベントの添付ファイルを取得するAPI
 */
export async function getEventAttachments({eventUrl, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/me/event/attachments`, {
        params: {
            rotaryCd: rotaryCd,
            url: eventUrl
        }
    })

    return JSON.parse(JSON.stringify(response.data))
}